import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';

const ContractsContext = createContext({});

export const ContractsContextProvider = ({ children }) => {
  const [initialContractValues, setInitialContractValues] = useState(null);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [updateStatusVisible, setUpdateStatusVisible] = useState(false);
  const [updateDetailsVisible, setUpdateDetailsVisible] = useState(false);
  const { dispatchAPI } = useAuthContext();
  const [enums, setEnums] = useState();
  const { message } = useErrorMessage();

  const getEnums = async () => {
    try {
      const { data } = await dispatchAPI('GET', { url: '/contracts/enums' });
      setEnums(data);
    } catch (e) {
      if (e.response) message(e.response.status);
    }
  };

  useEffect(() => {
    (async () => {
      await getEnums();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <ContractsContext.Provider
      value={{
        initialContractValues,
        setInitialContractValues,
        updateStatusVisible,
        setUpdateStatusVisible,
        updateDetailsVisible,
        setUpdateDetailsVisible,
        forceRefresh,
        setForceRefresh,
        enums
      }}
    >
      {children}
    </ContractsContext.Provider>
  );
};

ContractsContextProvider.propTypes = {
  children: PropTypes.element.isRequired
};

export default () => useContext(ContractsContext);
